import React, { useState } from "react";
import { Card, CardBody, Button } from "reactstrap";
import axios from "axios";
import { injectIntl } from "react-intl";
import IntlMessages from "../../helpers/IntlMessages";
import { END_POINT } from "../../constants/defaultValues";
import {
  NotificatioErrController,
  NotificatioSucController,
} from "../../helpers/Utils";

const TemplateWarningCard = ({
  className = "",
  intl,
  onDismissed,
  compact = false,
}) => {
  const [isDismissing, setIsDismissing] = useState(false);

  const handleDismiss = async () => {
    const confirmText =
      intl?.formatMessage({ id: "home.warning.dismiss-confirm" }) ||
      "Bạn có chắc chắn muốn ẩn toàn bộ dữ liệu mẫu không?";
    if (!window.confirm(confirmText)) {
      return;
    }

    setIsDismissing(true);
    try {
      const tokenStr = localStorage.getItem("access_token");
      await axios.put(
        `${END_POINT}/user/template-visibility`,
        { showTemplate: false },
        { headers: { Authorization: `Bearer ${tokenStr}` } },
      );
      const successText =
        intl?.formatMessage({ id: "home.warning.dismiss-success" }) ||
        "Đã ẩn dữ liệu mẫu thành công!";
      NotificatioSucController(successText);
      if (onDismissed) {
        onDismissed();
      }
    } catch (err) {
      const errorText =
        err.response?.data?.responseText ||
        err.response?.data?.message ||
        "Có lỗi xảy ra khi ẩn dữ liệu mẫu";
      NotificatioErrController(errorText);
    } finally {
      setIsDismissing(false);
    }
  };

  return (
    <Card
      className={`template-warning-card ${className}`}
      style={{
        backgroundColor: "#fff5f5",
        borderColor: "#f5c6cb",
        borderRadius: "0.75rem",
      }}
    >
      <CardBody
        className={`${
          compact ? "p-2" : "p-3"
        } d-flex align-items-center justify-content-between flex-wrap`}
        style={{ color: "#721c24", gap: "0.5rem" }}
      >
        <div className="d-flex align-items-center flex-grow-1 mr-2">
          <i
            className="simple-icon-info mr-2 text-danger"
            style={{ fontSize: compact ? "1rem" : "1.2rem", flexShrink: 0 }}
          />
          <span
            className={
              compact ? "small font-weight-medium" : "font-weight-medium"
            }
          >
            <IntlMessages id="home.warning.dismiss-template" />
          </span>
        </div>
        <div className="d-flex align-items-center">
          <Button
            color="danger"
            size={compact ? "xs" : "sm"}
            outline
            disabled={isDismissing}
            onClick={handleDismiss}
            style={{
              fontWeight: "600",
              whiteSpace: "nowrap",
            }}
          >
            {isDismissing ? (
              <span className="spinner-border spinner-border-sm mr-1" />
            ) : (
              <i className="simple-icon-eye mr-1" />
            )}
            <IntlMessages id="home.warning.dismiss-btn" />
          </Button>
        </div>
      </CardBody>
    </Card>
  );
};

export default injectIntl(TemplateWarningCard);
